import users from './users'
import languages from './languages'
import courses from './courses'
import zones from './zones'
import pointsOfInterest from './pointsOfInterest'
import games from './games'

export default {
  users,
  languages,
  courses,
  zones,
  pointsOfInterest,
  games
}